import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import Select from 'react-select';
import { FormControl } from 'react-bootstrap';

import './Petition.less';

// import data
import assetsAndLiablities from '../../data/assetsAndLiabilities';
import industryData from '../../data/industry';
import noOfCreditorsData from '../../data/noOfCreditors';
import debtorBusinessData from '../../data/debtorBusiness';
import ch11TypeData from '../../data/ch11Type';

class PetitionForm extends Component {
  static propTypes = {
    schedule: PropTypes.any.isRequired,
    onSubmit: PropTypes.func,
    toggleFilterSection: PropTypes.func,
    loadingSpinner: PropTypes.bool,
    showFilterSection: PropTypes.bool,
  };

  static defaultProps = {
    onSubmit: () => null,
    toggleFilterSection: () => null,
    loadingSpinner: false,
    showFilterSection: true,
  };

  render() {
    const { schedule, onSubmit } = this.props;
    const { data = {}, header = {} } = schedule;
    const SelectField = ({ input, ...rest }) => (
      <Select
        {...input}
        {...rest}
        onBlurResetsInput={false}
        onSelectResetsInput={false}
        simpleValue
        autosize
        searchable
      />
    );

    const InputField = ({ input, ...rest }) => <FormControl {...input} {...rest} />;

    function getByLabel(collection, label, defaultVal) {
      if (!label) return defaultVal;
      const option = collection.find((option) => option.label === label);
      if (!option) return defaultVal;
      return option.value;
    }

    const estimated_assets = getByLabel(assetsAndLiablities, header && header.estimated_assets, 'Unknown');
    const estimated_number_of_creditors = getByLabel(
      noOfCreditorsData,
      data && data.estimated_number_of_creditors,
      'Unknown'
    );
    const describe_debtor_business = getByLabel(debtorBusinessData, data && data.describe_debtor_business, 'None');
    const estimated_liabilities = getByLabel(assetsAndLiablities, header && header.estimated_liabilities, 'Unknown');
    const naics =
      header && header.naics
        ? industryData.filter((industryValue) => industryValue.label.indexOf(header.naics) >= 0)[0].value
        : '';
    const ch11_type = getByLabel(ch11TypeData, header && header.ch11_type, '');

    // prettier-ignore
    const initialData = {
      estimated_assets,
      estimated_liabilities,
      naics,
      ch11_type,
      estimated_number_of_creditors,
      describe_debtor_business,
      website                             : header.website,
      location_place_of_business_city     : data ? data.location_place_of_business_city : '',
      location_place_of_business_state    : data ? data.location_place_of_business_state : '',
      location_place_of_business_street   : data ? data.location_place_of_business_street : '',
      location_place_of_business_zip_code : data ? data.location_place_of_business_zip_code : '',
      location_place_of_business_country  : data ? data.location_place_of_business_country : '',
      principal_place_of_business_city    : data ? data.principal_place_of_business_city : '',
      principal_place_of_business_state   : data ? data.principal_place_of_business_state : '',
      principal_place_of_business_street  : data ? data.principal_place_of_business_street : '',
      principal_place_of_business_zip_code: data ? data.principal_place_of_business_zip_code : '',
      principal_place_of_business_country : data ? data.principal_place_of_business_country : '',
      debtor_estimate_of_available_funds  : data ? data.debtor_estimate_of_available_funds : '',
      authorized_representative_of_debtor : data ? data.authorized_representative_of_debtor : '',
      title                               : data ? data.title : '',
    };

    return (
      <Form
        initialValues={initialData}
        onSubmit={onSubmit}
        render={({ handleSubmit, pristine, submitting }) => (
          <form onSubmit={handleSubmit} id="parser-schedule-petition-form">
            <fieldset className="ir-search-double">
              <table id="petition">
                <tbody>
                  <tr>
                    <td>
                      <label>
                        <span className="label-petitioner">Principal place of business:</span>
                      </label>
                    </td>
                    <td>
                      <label>
                        <span className="label-petitioner">Location of principal assets:</span>
                      </label>
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td>
                      <label>
                        <span className="label">Street</span>
                      </label>
                      <Field name="principal_place_of_business_street" component={InputField} placeholder="Street" />
                    </td>
                    <td>
                      <label>
                        <span className="label">Street</span>
                      </label>
                      <Field name="location_place_of_business_street" component={InputField} placeholder="Street" />
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td>
                      <label>
                        <span className="label">City</span>
                      </label>
                      <Field name="principal_place_of_business_city" component={InputField} placeholder="City" />
                    </td>
                    <td>
                      <label>
                        <span className="label">City</span>
                      </label>
                      <Field name="location_place_of_business_city" component={InputField} placeholder="City" />
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td>
                      <label>
                        <span className="label">State</span>
                      </label>
                      <Field name="principal_place_of_business_state" component={InputField} placeholder="State" />
                    </td>
                    <td>
                      <label>
                        <span className="label">State</span>
                      </label>
                      <Field name="location_place_of_business_state" component={InputField} placeholder="State" />
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td>
                      <label>
                        <span className="label">Zip Code</span>
                      </label>
                      <Field
                        name="principal_place_of_business_zip_code"
                        component={InputField}
                        placeholder="Zip Code"
                      />
                    </td>
                    <td>
                      <label>
                        <span className="label">Zip Code</span>
                      </label>
                      <Field name="location_place_of_business_zip_code" component={InputField} placeholder="Zip Code" />
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td>
                      <label>
                        <span className="label">Country</span>
                      </label>
                      <Field name="principal_place_of_business_country" component={InputField} placeholder="Country" />
                    </td>
                    <td>
                      <label>
                        <span className="label">Country</span>
                      </label>
                      <Field name="location_place_of_business_country" component={InputField} placeholder="Country" />
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td>
                      <label>
                        <span className="label">Describe debtor’s business</span>
                      </label>
                      <Field
                        name="describe_debtor_business"
                        component={SelectField}
                        options={debtorBusinessData}
                        rows="3"
                        cols="33"
                        placeholder="Describe debtor business"
                      />
                    </td>
                    <td>
                      <label>
                        <span className="label">Authorized representative of debtor</span>
                      </label>
                      <Field
                        name="authorized_representative_of_debtor"
                        component={InputField}
                        rows="3"
                        cols="33"
                        id="authorized_representative_of_debtor"
                      />
                    </td>
                    <td>
                      <label>
                        <span className="label">Title</span>
                      </label>
                      <Field name="title" component={InputField} rows="3" cols="33" id="title" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label>
                        <span className="label">Estimated number of creditors</span>
                      </label>
                      <Field
                        name="estimated_number_of_creditors"
                        component={SelectField}
                        options={noOfCreditorsData}
                        autosize
                        placeholder="Select number of Creditors"
                      />
                    </td>
                    <td>
                      <label>
                        <span className="label">Estimated assets</span>
                      </label>
                      <Field
                        name="estimated_assets"
                        component={SelectField}
                        options={assetsAndLiablities}
                        autosize
                        placeholder="Select new asset"
                      />
                    </td>
                    <td>
                      <label>
                        <span className="label">Estimated liabilities</span>
                      </label>
                      <Field
                        name="estimated_liabilities"
                        component={SelectField}
                        options={assetsAndLiablities}
                        autosize
                        placeholder="Select new liability"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="2">
                      <label>
                        <span className="label">Website</span>
                      </label>
                      <Field
                        name="website"
                        component={InputField}
                        type="text"
                        id="website"
                        placeholder="Enter new website"
                      />
                    </td>
                    <td>
                      <label>
                        <span className="label">Chapter 11 Type</span>
                      </label>
                      <Field
                        name="ch11_type"
                        component={SelectField}
                        options={ch11TypeData}
                        placeholder="Select new chanel 11 type"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="3">
                      <label>
                        <span className="label">Naics (4-digit code) </span>
                      </label>
                      <Field
                        name="naics"
                        component={SelectField}
                        autosize
                        options={industryData}
                        placeholder="Select new industry"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="buttons">
                <button type="submit" disabled={submitting || pristine} className="btn btn-primary">
                  Submit Changes
                </button>

                <button
                  type="button"
                  onClick={() => {
                    if (
                      pristine ||
                      confirm(
                        'You are about to lose unsaved changes!\nPress "Cancel" to continue editing, "OK" to discard changes!'
                      )
                    )
                      this.props.onCancel();
                  }}
                  disabled={submitting}
                  className={`btn btn-link ${pristine ? '' : 'cancel-link'}`}
                >
                  {pristine ? 'Cancel Editing' : 'Discard Changes'}
                </button>
              </div>
            </fieldset>
          </form>
        )}
      />
    );
  }
}

export default PetitionForm;



// WEBPACK FOOTER //
// ./src/scheduleform/petition/PetitionForm.jsx